import { getSession } from "next-auth/react"

export const getProfile = async () => {
  const session = await getSession()
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/users/profile`,
      { headers: { "Content-Type": "application/json", Authorization: `Bearer ${session?.accessToken}` }, },
      { cache: 'no-store' }
    )
    if (!res.ok) {
      return []
    }
    const result = await res.json()
    return result.data || []  // ✅ return only the data array
  } catch (error) {
    return []
  }
}